import { render } from "./AutoFacturations.vue?vue&type=template&id=b8a1a320&scoped=true"
import script from "./AutoFacturations.vue?vue&type=script&lang=js"
export * from "./AutoFacturations.vue?vue&type=script&lang=js"

import "./AutoFacturations.vue?vue&type=style&index=0&id=b8a1a320&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekaliAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8a1a320"]])

export default __exports__